'use client';

import { createContext, useContext, useEffect, useState, useMemo } from 'react'
import { useGetListProperties } from '@src/apis/list-listing/query';
import { useGetCityByCoor } from '@src/apis/shared/query/use-get-city-by-coor';

const HomepageCtx = createContext();

export const HomepageProvider = ({ children, name }) => {
  const [coor, setCoor] = useState({
    "coordinates[lat]": null,
    "coordinates[lng]": null
  })
  const [kind, setKind] = useState("homepage")

  const filledCoord = !!coor['coordinates[lat]'] && !!coor['coordinates[lng]']

  const [isIndonesia, setIsIndonesia] = useState(false)

  const { data: listListing, isLoading = true } = useGetListProperties({
    params: {
      property_category_ids: "1,2",
      grouping: true,
      kind: kind,
      ...coor
    },
    options: { enabled: isIndonesia || filledCoord }
  })

  const { data: city } = useGetCityByCoor({ params: coor, options: { enabled: filledCoord } })

  const dataCity = useMemo(() => {
    return city?.data?.data
  }, [city])

  useEffect(() => {
    if (!navigator.geolocation) {
      setIsIndonesia(true)

      throw new Error("Geolocation is not supported by this browser.")
    }

    navigator.geolocation.getCurrentPosition(({ coords }) => {
      setCoor({
        "coordinates[lat]": coords.latitude,
        "coordinates[lng]": coords.longitude
      })
    }, () => {
      setIsIndonesia(true)
      setKind(null)
    });
  }, [])

  return (
    <HomepageCtx.Provider value={{
      listListing,
      isLoading,
      name,
      dataCity,
      isIndonesia: isIndonesia || (listListing?.pages?.[0]?.headers?.["x-search"] ?? "").toLowerCase() === "indonesia"
    }}>
      {children}
    </HomepageCtx.Provider>
  )
}


const useHomepageCtx = () => {
  const ctx = useContext(HomepageCtx);

  if (!ctx) {
    throw new Error("useHomepageCtx must be used within the HomepageProvider");
  }

  return ctx;
};


export default useHomepageCtx